/* Helper Functions Start */
window.customShowToast = function(eventName, message) {
    document.dispatchEvent(
        new CustomEvent(eventName, {
            detail: { titleText: message },
        })
    );
}
/* Helper Functions End */

function initializeSwymWishlist() {
    /* Wishlist Configurations Start */
    const CFG = {
        selectors: {
            productGrid: ".collection-products, .product-grid-list",
            productCard:
                ".product-card-wrapper",
            imageWrapper: ".product-img-wrapper, .product-img-link",
            productLink: '[href*="/products/"]',
        },
        addedClass: "swc-btn--added",
        loadingClass: "swc-btn--loading",
        popupId: "wishlistVariantModal",
    };

    let wishlistState = {};
    const wishlistedHandles = new Set();
    const shopifyProductCache = {};
    let _swat = null;

    const HEART_OUTLINE =
        '<svg class="swc-icon swc-icon--outline" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
    const HEART_FILLED =
        '<svg class="swc-icon swc-icon--filled" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    /* Wishlist Configurations End */

    /* Wishlist Product Card Start */
    const getHandleFromUrl = (url) => {
        try {
            const pathParts = new URL(
                url,
                window.location.origin
            ).pathname.split("/");
            const idx = pathParts.indexOf("products");
            return idx !== -1 && pathParts.length > idx + 1
                ? pathParts[idx + 1].split("?")[0]
                : null;
        } catch (e) {
            const match = url.match(/\/products\/([^/?#]+)/);
            return match ? match[1].split("?")[0] : null;
        }
    };

    const fetchShopifyProduct = async (handle) => {
        if (!handle) return null;

        if (!shopifyProductCache[handle]) {
            const shopifyRoot =
                window.Shopify &&
                window.Shopify.routes &&
                window.Shopify.routes.root
                    ? window.Shopify.routes.root
                    : "/";
            shopifyProductCache[handle] = fetch(
                `${shopifyRoot}products/${handle}.js`
            )
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("Product not found");
                    }
                    return res.json();
                })
                .catch((err) => {
                    delete shopifyProductCache[handle];
                    console.error(
                        `[Wishlist] Shopify fetch error for ${handle}:`,
                        err
                    );
                    return null;
                });
        }
        return await shopifyProductCache[handle];
    };

    function isProductWishlisted(productId) {
        return !!(
            wishlistState[productId] && wishlistState[productId].size > 0
        );
    }

    function isVariantWishlisted(productId, variantId) {
        return !!(
            wishlistState[productId] &&
            wishlistState[productId].has(String(variantId))
        );
    }

    function buildStateFromFetch(items) {
        wishlistState = {};
        wishlistedHandles.clear();
        items.forEach(function (item) {
            const productId = String(item.empi);
            const variantId = String(item.epi);

            if (!wishlistState[productId]) wishlistState[productId] = new Set();
            wishlistState[productId].add(variantId);

            if (item.du) {
                const handle = getHandleFromUrl(item.du);
                if (handle) wishlistedHandles.add(handle);
            }
        });
    }

    function setButtonState(btnElement, productId) {
        const isAdded = isProductWishlisted(productId);
        btnElement.classList.toggle(CFG.addedClass, isAdded);
        btnElement.setAttribute(
            "aria-label",
            isAdded ? "Remove from wishlist" : "Add to wishlist"
        );
        btnElement.innerHTML = isAdded ? HEART_FILLED : HEART_OUTLINE;
    }

    function setButtonLoading(btnElement, isLoading) {
        btnElement.classList.toggle(CFG.loadingClass, isLoading);
        btnElement.disabled = isLoading;
    }

    function isFutureLaunchDate(variantId) {
        const variantLaunchDate =
            window.variantLaunchDates && window.variantLaunchDates[variantId];
        if (!variantLaunchDate) return false;

        const nowMs = window.storeNow ? window.storeNow * 1000 : Date.now();
        const storeOffset = window.storeOffset || "+0000";
        const formattedOffset =
            storeOffset.slice(0, 3) + ":" + storeOffset.slice(3);
        const launchDateMs = Date.parse(
            `${variantLaunchDate}T00:00:00${formattedOffset}`
        );

        return launchDateMs > nowMs;
    }

    function injectInitialUI() {
        const productCards = document.querySelectorAll(
            CFG.selectors.productCard
        );

        productCards.forEach(function (card) {
            if (card.getAttribute('data-swym-wl-disabled') === 'true') return;

            if (card.querySelector(".swc-wishlist-btn")) return;

            const productLink = card.querySelector(CFG.selectors.productLink);
            if (!productLink) return;

            const wishlistBtn = document.createElement("button");
            wishlistBtn.className = "swc-wishlist-btn";
            wishlistBtn.type = "button";
            wishlistBtn.setAttribute("aria-label", "Add to wishlist");
            wishlistBtn.innerHTML = HEART_OUTLINE;
            wishlistBtn.style.pointerEvents = "none";

            const imageWrapper = card.querySelector(CFG.selectors.imageWrapper);
            const targetElement = imageWrapper || card;
            targetElement.appendChild(wishlistBtn);
        });

        const pdpContainer = document.querySelector(
            ".swym-wishlist-pdp-container"
        );
        if (pdpContainer && !pdpContainer.querySelector(".swc-wishlist-btn")) {
            pdpContainer.style.cursor = "pointer";
            pdpContainer.style.display = "flex";

            const pdpBtn = document.createElement("button");
            pdpBtn.type = "button";
            pdpBtn.className = "swc-wishlist-btn";
            pdpBtn.style.position = "relative";
            pdpBtn.style.bottom = "auto";
            pdpBtn.style.right = "auto";
            pdpBtn.style.display = "inline-flex";
            pdpBtn.style.pointerEvents = "none";
            pdpBtn.setAttribute("aria-label", "Add to wishlist");
            pdpBtn.innerHTML = HEART_OUTLINE;

            pdpContainer.appendChild(pdpBtn);
        }
    }

    function hydrateGridButtons() {
        const productCards = document.querySelectorAll(
            CFG.selectors.productCard
        );

        productCards.forEach(function (card) {
            if (card.getAttribute('data-swym-wl-disabled') === 'true') {
                return; 
            }

            let wishlistBtn = card.querySelector(".swc-wishlist-btn");

            if (!wishlistBtn) {
                const productLink = card.querySelector(
                    CFG.selectors.productLink
                );
                if (!productLink) return;

                wishlistBtn = document.createElement("button");
                wishlistBtn.className = "swc-wishlist-btn";
                wishlistBtn.type = "button";
                wishlistBtn.setAttribute("aria-label", "Add to wishlist");
                wishlistBtn.innerHTML = HEART_OUTLINE;

                const imageWrapper = card.querySelector(
                    CFG.selectors.imageWrapper
                );
                const targetElement = imageWrapper || card;
                targetElement.appendChild(wishlistBtn);
            }

            if (wishlistBtn.hasAttribute("data-swym-hydrated")) return;

            const productLink = card.querySelector(CFG.selectors.productLink);
            if (!productLink) return;

            const hrefStr = productLink.getAttribute("href");
            if (!hrefStr) return;

            const rawUrl = hrefStr.startsWith("http")
                ? hrefStr
                : window.location.origin + hrefStr;
            const productUrl = rawUrl.split("?")[0];
            const productHandle = getHandleFromUrl(productUrl);

            if (!productHandle) return;

            wishlistBtn.setAttribute("data-product-handle", productHandle);
            wishlistBtn.setAttribute("data-product-url", productUrl);
            wishlistBtn.setAttribute("data-swym-hydrated", "true");
            wishlistBtn.style.pointerEvents = "auto";

            const cachedProductId = card.getAttribute("data-swc-empi");

            if (cachedProductId) {
                setButtonState(wishlistBtn, cachedProductId);
            } else if (wishlistedHandles.has(productHandle)) {
                wishlistBtn.classList.add(CFG.addedClass);
                wishlistBtn.setAttribute("aria-label", "Manage Wishlist");
                wishlistBtn.innerHTML = HEART_FILLED;
            }

            wishlistBtn.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleHeartClick(wishlistBtn, productHandle, productUrl);
            });
        });
    }

    async function handleHeartClick(btnElement, productHandle, productUrl) {
        if (btnElement.disabled) return;
        setButtonLoading(btnElement, true);

        const shopifyProduct = await fetchShopifyProduct(productHandle);

        if (!shopifyProduct) {
            setButtonLoading(btnElement, false);
            window.customShowToast(
                "ShowToast",
                "Product information is currently unavailable."
            );
            return;
        }

        const tags = shopifyProduct.tags || [];
        if (tags.includes('swym-wl-disabled')) {
            setButtonLoading(btnElement, false);
            btnElement.remove();
            window.customShowToast("ShowToast", "This product cannot be added to the wishlist.");
            return;
        }

        const productId = shopifyProduct.id;
        const productVariants = shopifyProduct.variants || [];
        const productOptions = shopifyProduct.options || [];
        const productImages = shopifyProduct.images || [];
        const productTitle = shopifyProduct.title || "";
        const productImageUrl =
            shopifyProduct.featured_image ||
            (productImages.length > 0 ? productImages[0] : "");
        const productPrice = shopifyProduct.price || 0;
        const compareAtPrice = shopifyProduct.compare_at_price || null;

        const parentCard = btnElement.closest(CFG.selectors.productCard);
        if (parentCard) {
            parentCard.setAttribute("data-swc-empi", String(productId));
        }

        setButtonLoading(btnElement, false);
        setButtonState(btnElement, productId);

        if (productVariants.length > 1) {
            openVariantPopup({
                btn: btnElement,
                empi: productId,
                variants: productVariants,
                options: productOptions,
                images: productImages,
                title: productTitle,
                imageUrl: productImageUrl,
                price: productPrice,
                compare_at_price: compareAtPrice,
                du: productUrl,
            });
        } else {
            if (isProductWishlisted(productId)) {
                const wishlistedVariants = wishlistState[productId]
                    ? Array.from(wishlistState[productId])
                    : [];
                const variantIdToRemove = wishlistedVariants[0] || productId;
                doRemove(
                    btnElement,
                    productId,
                    parseInt(variantIdToRemove, 10),
                    productUrl,
                    productTitle,
                    productImageUrl,
                    productPrice
                );
            } else {
                const variantIdToAdd =
                    productVariants.length === 1
                        ? productVariants[0].id
                        : productId;
                doAdd(
                    btnElement,
                    productId,
                    variantIdToAdd,
                    productUrl,
                    productTitle,
                    productImageUrl,
                    productPrice
                );
            }
        }
    }

    function doAdd(
        btnElement,
        productId,
        variantId,
        productUrl,
        productTitle,
        productImageUrl,
        productPrice,
        onSuccess
    ) {
        const numericProductId = parseInt(productId, 10);
        const numericVariantId = parseInt(variantId, 10);

        const productPayload = {
            empi: numericProductId,
            epi: numericVariantId,
            du: productUrl,
            dt: productTitle,
            iu: productImageUrl,
            pr: productPrice,
        };

        _swat.addToWishList(
            productPayload,
            function () {
                if (!wishlistState[String(productId)]) {
                    wishlistState[String(productId)] = new Set();
                }
                wishlistState[String(productId)].add(String(variantId));
                wishlistedHandles.add(getHandleFromUrl(productUrl));

                if (btnElement) {
                    setButtonLoading(btnElement, false);
                    setButtonState(btnElement, productId);
                }
                syncButtonsForProduct(productId);

                if (typeof onSuccess === "function") onSuccess();
            },
            function (err) {
                console.error("[Swym] addToWishList error", err);
                if (btnElement) {
                    setButtonLoading(btnElement, false);
                    setButtonState(btnElement, productId);
                }
                if (typeof onSuccess === "function") onSuccess();
            }
        );
    }

    function doRemove(
        btnElement,
        productId,
        variantId,
        productUrl,
        productTitle,
        productImageUrl,
        productPrice,
        onSuccess
    ) {
        const numericProductId = parseInt(productId, 10);
        const numericVariantId = parseInt(variantId, 10);

        const productPayload = {
            empi: numericProductId,
            epi: numericVariantId,
            du: productUrl,
            dt: productTitle,
            iu: productImageUrl,
            pr: productPrice,
        };

        _swat.removeFromWishList(
            productPayload,
            function () {
                if (wishlistState[String(productId)]) {
                    wishlistState[String(productId)].delete(String(variantId));
                    if (wishlistState[String(productId)].size === 0) {
                        delete wishlistState[String(productId)];
                        wishlistedHandles.delete(getHandleFromUrl(productUrl));
                    }
                }

                if (btnElement) {
                    setButtonLoading(btnElement, false);
                    setButtonState(btnElement, productId);
                }
                syncButtonsForProduct(productId);

                if (typeof onSuccess === "function") onSuccess();
            },
            function (err) {
                console.error("[Swym] removeFromWishList error", err);
                if (btnElement) {
                    setButtonLoading(btnElement, false);
                    setButtonState(btnElement, productId);
                }
                if (typeof onSuccess === "function") onSuccess();
            }
        );
    }

    function syncButtonsForProduct(productId) {
        const allWishlistBtns = document.querySelectorAll(".swc-wishlist-btn");
        allWishlistBtns.forEach(function (btnElement) {
            const parentCard = btnElement.closest("[data-swc-empi]");
            if (
                parentCard &&
                String(parentCard.getAttribute("data-swc-empi")) ===
                    String(productId)
            ) {
                setButtonState(btnElement, productId);
            }
        });
    }

    function ensurePopupExists() {
        if (document.getElementById(CFG.popupId)) return;

        const overlayElement = document.createElement("div");
        overlayElement.id = CFG.popupId;
        overlayElement.className =
            "wishlist-variant-modal wishlist-modal-overlay";
        overlayElement.innerHTML = [
            '<div class="modal-container">',
            '<button class="modal-close" id="wishlistModalClose" title="Close">',
            '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
            "</button>",
            '<div class="modal-content">',
            '<div class="modal-image">',
            '<img id="wishlistModalProductImage" src="" alt="Product Image">',
            "</div>",
            '<div class="modal-details">',
            '<div class="inner-wrap">',
            '<div class="product-details">',
            '<h2 class="product-title" id="wishlistModalProductTitle"></h2>',
            '<div class="price-wrapper">',
            '<p class="product-price" id="wishlistModalProductPrice"></p>',
            '<p class="product-compare-price" id="wishlistModalProductComparePrice"></p>',
            "</div>",
            "</div>",
            "<div>",
            '<p id="swc-popup-label" class="swc-popup-label"></p>',
            '<div id="wishlistModalVariantOptions" class="wishlist-variant-list"></div>',
            "</div>",
            "</div>",
            '<div class="swc-popup-footer">',
            '<button id="swcConfirmBtn" class="swc-confirm-btn" disabled>Add to Wishlist</button>',
            "</div>",
            "</div>",
            "</div>",
            "</div>",
        ].join("");

        document.body.appendChild(overlayElement);

        overlayElement.addEventListener("click", function (e) {
            if (e.target === overlayElement) closePopup();
        });
        document
            .getElementById("wishlistModalClose")
            .addEventListener("click", closePopup);
    }

    function openVariantPopup(opts) {
        opts.variants = opts.variants.filter(function (variant) {
            return !isFutureLaunchDate(variant.id);
        });

        if (opts.variants.length === 0) {
            window.customShowToast("ShowToast", "This product is coming soon!");
            return;
        }

        ensurePopupExists();

        const overlayElement = document.getElementById(CFG.popupId);
        const titleEl = document.getElementById("wishlistModalProductTitle");
        const priceEl = document.getElementById("wishlistModalProductPrice");
        const comparePriceEl = document.getElementById(
            "wishlistModalProductComparePrice"
        );
        const variantsEl = document.getElementById(
            "wishlistModalVariantOptions"
        );
        const labelEl = document.getElementById("swc-popup-label");
        const imgEl = document.getElementById("wishlistModalProductImage");
        const confirmBtn = document.getElementById("swcConfirmBtn");

        let currentSelectedVariant = null;

        titleEl.textContent = opts.title || "";
        imgEl.alt = opts.title || "Product Image";

        let optionHeader = "Variant";
        if (opts.options && opts.options.length > 0) {
            if (typeof opts.options[0] === "string") {
                optionHeader = opts.options[0];
            } else if (opts.options[0].name) {
                optionHeader = opts.options[0].name;
            }
        }

        function cleanUrl(url) {
            if (!url) return "";
            if (url.indexOf("//") === 0) return "https:" + url;
            return url;
        }

        function selectVariant(variant, buttonElement) {
            currentSelectedVariant = variant;

            variantsEl
                .querySelectorAll(".wishlist-variant-swatch")
                .forEach(function (swatchBtn) {
                    swatchBtn.classList.remove("is-selected");
                });

            if (buttonElement) buttonElement.classList.add("is-selected");

            const variantTitleText =
                variant.title || variant.name || "Variant " + variant.id;
            const commaSeparatedName = variantTitleText.replace(
                /\s*\/\s*/g,
                ", "
            );

            labelEl.innerHTML =
                '<span class="swc-label-header">' +
                optionHeader +
                ': </span><span class="swc-label-value">' +
                commaSeparatedName +
                "</span>";

            const displayPrice =
                variant.price !== undefined && variant.price !== null
                    ? variant.price
                    : opts.price;
            const displayComparePrice =
                variant.compare_at_price !== undefined &&
                variant.compare_at_price !== null
                    ? variant.compare_at_price
                    : opts.compare_at_price || null;

            const formattedPrice = displayPrice ? Utils.formatMoney(displayPrice) : "";
            priceEl.textContent = formattedPrice;

            if (displayComparePrice && displayComparePrice > displayPrice) {
                const formattedComparePrice = Utils.formatMoney(displayComparePrice);
                comparePriceEl.textContent = formattedComparePrice;
                comparePriceEl.style.display = "block";
            } else {
                comparePriceEl.style.display = "none";
            }

            if (variant.featured_image && variant.featured_image.src) {
                imgEl.src = cleanUrl(variant.featured_image.src);
            } else if (opts.imageUrl) {
                imgEl.src = cleanUrl(opts.imageUrl);
            } else if (opts.images && opts.images.length > 0) {
                imgEl.src = cleanUrl(opts.images[0]);
            }

            confirmBtn.disabled = false;

            if (isVariantWishlisted(opts.empi, variant.id)) {
                confirmBtn.textContent = "Remove from Wishlist";
            } else {
                confirmBtn.textContent = "Add to Wishlist";
            }
        }

        variantsEl.innerHTML = "";
        let firstButton = null;

        opts.variants.forEach(function (variant, index) {
            const optBtn = document.createElement("button");
            optBtn.className = "wishlist-variant-swatch";
            optBtn.type = "button";

            if (isVariantWishlisted(opts.empi, variant.id))
                optBtn.classList.add("is-wishlisted");

            if (index === 0) firstButton = optBtn;

            const variantTitleText =
                variant.title || variant.name || "Variant " + variant.id;
            const rawColorName = variantTitleText
                .split("/")[0]
                .trim()
                .toLowerCase();

            const hexColor =
                window.ShopifyBrandColors &&
                window.ShopifyBrandColors[rawColorName]
                    ? window.ShopifyBrandColors[rawColorName]
                    : null;

            if (hexColor) {
                optBtn.classList.add("wishlist-variant-swatch--color");
                optBtn.style.backgroundColor = hexColor;
                optBtn.setAttribute("title", variantTitleText);
            } else {
                optBtn.classList.add("wishlist-variant-swatch--text");
                optBtn.textContent = variantTitleText;
            }

            optBtn.addEventListener("click", function () {
                selectVariant(variant, optBtn);
            });

            variantsEl.appendChild(optBtn);
        });

        if (opts.variants.length > 0 && firstButton) {
            selectVariant(opts.variants[0], firstButton);
        }

        confirmBtn.onclick = function () {
            if (!currentSelectedVariant || confirmBtn.disabled) return;

            confirmBtn.disabled = true;
            confirmBtn.classList.add("is-loading");

            const isWishlisted = isVariantWishlisted(
                opts.empi,
                currentSelectedVariant.id
            );
            const activeSwatch = variantsEl.querySelector(
                ".wishlist-variant-swatch.is-selected"
            );

            if (isWishlisted) {
                doRemove(
                    opts.btn,
                    opts.empi,
                    currentSelectedVariant.id,
                    opts.du,
                    opts.title,
                    opts.imageUrl,
                    opts.price,
                    function () {
                        confirmBtn.classList.remove("is-loading");
                        confirmBtn.textContent = "Add to Wishlist";
                        confirmBtn.disabled = false;
                        if (activeSwatch)
                            activeSwatch.classList.remove("is-wishlisted");
                    }
                );
            } else {
                doAdd(
                    opts.btn,
                    opts.empi,
                    currentSelectedVariant.id,
                    opts.du,
                    opts.title,
                    opts.imageUrl,
                    opts.price,
                    function () {
                        confirmBtn.classList.remove("is-loading");
                        confirmBtn.textContent = "Remove from Wishlist";
                        confirmBtn.disabled = false;
                        if (activeSwatch)
                            activeSwatch.classList.add("is-wishlisted");
                    }
                );
            }
        };

        overlayElement.classList.add("is-open");
        document.body.style.overflow = "hidden";
    }

    function closePopup() {
        const overlayElement = document.getElementById(CFG.popupId);
        
        if (overlayElement) {
            overlayElement.classList.remove("is-open");
            
            setTimeout(function() {
                const titleEl = document.getElementById("wishlistModalProductTitle");
                const priceEl = document.getElementById("wishlistModalProductPrice");
                const comparePriceEl = document.getElementById("wishlistModalProductComparePrice");
                const variantsEl = document.getElementById("wishlistModalVariantOptions");
                const labelEl = document.getElementById("swc-popup-label");
                const imgEl = document.getElementById("wishlistModalProductImage");

                if (titleEl) titleEl.textContent = "";
                if (priceEl) priceEl.textContent = "";
                if (comparePriceEl) {
                    comparePriceEl.textContent = "";
                    comparePriceEl.style.display = "none";
                }
                if (variantsEl) variantsEl.innerHTML = "";
                if (labelEl) labelEl.innerHTML = "";
                if (imgEl) {
                    imgEl.removeAttribute("src");
                    imgEl.alt = "";
                }
            }, 300);
        }
        document.body.style.overflow = "";
    }

    function observeGrid() {
        const gridElement = document.querySelector(CFG.selectors.productGrid);
        if (!gridElement) return;

        const observer = new MutationObserver(function () {
            hydrateGridButtons();
        });
        observer.observe(gridElement, { childList: true, subtree: true });
    }
    /* Wishlist Product Card End */

    /* PDP Wishlist Logic Start */
    function initPDPWishlist(swat) {
        const pageData = window.SwymPageData;
        if (!pageData || pageData.et !== 1) return;

        const pdpContainer = document.querySelector(
            ".swym-wishlist-pdp-container"
        );
        if (!pdpContainer) return;

        if (pdpContainer.getAttribute('data-swym-wl-disabled') === 'true') {
            pdpContainer.style.display = 'none';
            return;
        }

        pdpContainer.style.cursor = "pointer";
        pdpContainer.style.display = "flex";

        let pdpWishlistBtn = pdpContainer.querySelector(".swc-wishlist-btn");
        if (!pdpWishlistBtn) {
            pdpWishlistBtn = document.createElement("button");
            pdpWishlistBtn.type = "button";
            pdpWishlistBtn.className = "swc-wishlist-btn";
            pdpWishlistBtn.style.position = "relative";
            pdpWishlistBtn.style.bottom = "auto";
            pdpWishlistBtn.style.right = "auto";
            pdpWishlistBtn.style.display = "inline-flex";
            pdpWishlistBtn.setAttribute("aria-label", "Add to wishlist");
            pdpWishlistBtn.innerHTML = HEART_OUTLINE;
            pdpContainer.appendChild(pdpWishlistBtn);
        }

        pdpWishlistBtn.style.pointerEvents = "auto";

        const productPayload = {
            epi: pageData.epi,
            empi: pageData.empi,
            du: pageData.du,
            dt: pageData.dt,
            iu: pageData.iu,
            pr: pageData.pr,
        };

        function updatePdpButtonState(isWishlisted) {
            if (!pdpWishlistBtn) return;
            pdpWishlistBtn.classList.toggle("swc-btn--added", isWishlisted);
            pdpWishlistBtn.innerHTML = isWishlisted ? HEART_FILLED : HEART_OUTLINE;
            pdpWishlistBtn.setAttribute(
                "aria-label",
                isWishlisted ? "Remove from wishlist" : "Add to wishlist"
            );
        }

        function checkPdpState() {
            swat.fetch(function (wishlisted) {
                const isFound = wishlisted.some(function (item) {
                    return (
                        String(item.empi) === String(productPayload.empi) &&
                        String(item.epi) === String(productPayload.epi)
                    );
                });
                updatePdpButtonState(isFound);
            });
        }

        checkPdpState();

        pdpContainer.onclick = function (e) {
            e.preventDefault();

            if (pdpWishlistBtn.disabled) return;

            pdpWishlistBtn.disabled = true;
            pdpWishlistBtn.classList.add("swc-btn--loading");

            if (pdpWishlistBtn.classList.contains("swc-btn--added")) {
                swat.removeFromWishList(
                    productPayload,
                    function () {
                        updatePdpButtonState(false);
                        pdpWishlistBtn.classList.remove("swc-btn--loading");
                        pdpWishlistBtn.disabled = false;
                    },
                    function () {
                        pdpWishlistBtn.classList.remove("swc-btn--loading");
                        pdpWishlistBtn.disabled = false;
                    }
                );
            } else {
                swat.addToWishList(
                    productPayload,
                    function () {
                        updatePdpButtonState(true);
                        pdpWishlistBtn.classList.remove("swc-btn--loading");
                        pdpWishlistBtn.disabled = false;
                    },
                    function () {
                        pdpWishlistBtn.classList.remove("swc-btn--loading");
                        pdpWishlistBtn.disabled = false;
                    }
                );
            }
        };

        swat.evtLayer.addEventListener(
            swat.JSEvents.variantChanged,
            function (evt) {
                const variantData = evt && evt.detail && evt.detail.d;
                if (!variantData) return;

                const newVariantId = variantData.variant
                    ? variantData.variant.id
                    : null;
                if (!newVariantId) return;

                const variantInfo =
                    window.SwymProductVariants &&
                    window.SwymProductVariants[newVariantId];

                if (variantInfo) {
                    productPayload.epi = variantInfo.epi;
                    productPayload.pr = variantInfo.pr;
                    productPayload.iu = variantInfo.iu || productPayload.iu;
                } else {
                    productPayload.epi = newVariantId;
                }

                checkPdpState();
            }
        );

        swat.evtLayer.addEventListener("sw:addedtowishlist", function (e) {
            if (
                e.detail &&
                e.detail.d &&
                String(e.detail.d.epi) === String(productPayload.epi)
            ) {
                updatePdpButtonState(true);
            }
        });

        swat.evtLayer.addEventListener("sw:removedfromwishlist", function (e) {
            if (
                e.detail &&
                e.detail.d &&
                String(e.detail.d.epi) === String(productPayload.epi)
            ) {
                updatePdpButtonState(false);
            }
        });
    }
    /* PDP Wishlist Logic End */

    function init(swat) {
        _swat = swat;

        swat.evtLayer.addEventListener(
            "sw:addedtowishlist",
            async function (e) {
                const eventData = e.detail.d;
                const handle = getHandleFromUrl(eventData.du);

                const shopifyProduct = await fetchShopifyProduct(handle);
                let baseTitle = eventData.dt || "Product";
                let variantTitle = "";

                if (shopifyProduct) {
                    baseTitle = shopifyProduct.title || baseTitle;
                    const productVariants = shopifyProduct.variants || [];
                    const matchedVariant = productVariants.find(
                        (v) => String(v.id) === String(eventData.epi)
                    );

                    if (matchedVariant) {
                        variantTitle =
                            matchedVariant.title || matchedVariant.name;
                    }
                }

                const nameLabel =
                    variantTitle && variantTitle !== "Default Title"
                        ? `${baseTitle} (${variantTitle})`
                        : baseTitle;

                window.customShowToast("ShowToast", `${nameLabel} added to wishlist`);
            }
        );

        swat.evtLayer.addEventListener(
            "sw:removedfromwishlist",
            async function (e) {
                const eventData = e.detail.d;
                const handle = getHandleFromUrl(eventData.du);

                const shopifyProduct = await fetchShopifyProduct(handle);
                let baseTitle = eventData.dt || "Product";
                let variantTitle = "";

                if (shopifyProduct) {
                    baseTitle = shopifyProduct.title || baseTitle;
                    const productVariants = shopifyProduct.variants || [];
                    const matchedVariant = productVariants.find(
                        (v) => String(v.id) === String(eventData.epi)
                    );
                    if (matchedVariant) {
                        variantTitle =
                            matchedVariant.title || matchedVariant.name;
                    }
                }

                const nameLabel =
                    variantTitle && variantTitle !== "Default Title"
                        ? `${baseTitle} (${variantTitle})`
                        : baseTitle;

                window.customShowToast("ShowToast", `${nameLabel} removed from wishlist`);
            }
        );

        swat.evtLayer.addEventListener("sw:addedtocart", function (e) {
            if (typeof window.updateCartCount === "function") {
                window.updateCartCount(false);
            } else {
                console.warn(
                    "updateCartCount function is not globally available."
                );
            }

            const productData = e.detail.d.productData;
            let productName = productData.name || "Product";

            if (productData.public_title) {
                const baseProductName = productName.replace(
                    new RegExp(`\\s-\\s${productData.public_title}$`),
                    ""
                );

                productName = `${baseProductName} (${productData.public_title})`;
            }

            document.dispatchEvent(
                new CustomEvent("AddToCart", {
                    detail: { productName },
                })
            );
        });

        swat.fetch(function (wishlisted) {
            buildStateFromFetch(wishlisted || []);
            hydrateGridButtons();
            observeGrid();
        });

        initPDPWishlist(swat);
    }

    // Attach immediate UI injection to the DOM
    document.addEventListener("DOMContentLoaded", injectInitialUI);

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(init);
}

initializeSwymWishlist();